import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@ciam/library';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

import { CountryDetailsResponse } from '../../shared/models/CountryDetailsResponse';
import { CountryListResponse } from '../../shared/models/CountryListResponse';
import { CityListResponse } from '../../shared/models/CityListResponse';
import { CityListRequest, Criteria, Address } from '../../shared/models/CityListRequest';
import { DialingPrefixResponse } from 'src/app/shared/models/DialingPrefixResponse';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private http: HttpClient, private config: ConfigurationService) { }

    // To get country Details
  getCountryDetails(countryCode: any): Observable<CountryDetailsResponse> {
    const countriesUrl = this.config.select('endpoints.countries.url') + '/' + countryCode;
    return this.http.get(countriesUrl, { withCredentials: true }).pipe(timeout(this.config.select('endpoints.countries.timeout')));
  }

  getCountryList(): Observable<CountryListResponse> {
    const countryListUrl = this.config.select<string>('endpoints.countries.url');
    return this.http.get(countryListUrl, { withCredentials: true }).pipe(timeout(Number(this.config.select<number>('endpoints.countries.timeout'))));
  }

  // To get phone dialing prefixes code for countries
  getDialingPrefixList(): Observable<DialingPrefixResponse> {
    const dialingPrefixesUrl = this.config.select<string>('endpoints.dialing_prefixes.url');
    return this.http.get(dialingPrefixesUrl, { withCredentials: true }).pipe(timeout(Number(this.config.select<number>('endpoints.dialing_prefixes.timeout'))));
  }

  getCities(countryCode: any, postalCode: any): Observable<CityListResponse> {
    const cityListUrl = this.config.select<string>('endpoints.cities.url');
    return this.http.post(
      cityListUrl,
      this.generateCityRequestPayload(countryCode, postalCode),
      { withCredentials: true }
    ).pipe(timeout(Number(this.config.select<number>('endpoints.cities.timeout'))));
  }

  generateCityRequestPayload(countryCode: any, postalCode: any): CityListRequest {
    const payload = {} as CityListRequest;
    payload.matchAndResultsCriteria = {} as Criteria;
    payload.matchAndResultsCriteria.address = {} as Address;
    payload.matchAndResultsCriteria.address.countryCode = countryCode;
    payload.matchAndResultsCriteria.address.postalCode = postalCode;
    payload.matchAndResultsCriteria.matchConditions = ['MATCH_BY_EXACT_POSTAL_CODE'];
    payload.matchAndResultsCriteria.resultsToSkip = '0';
    return payload;
  }
}


